module.exports = __webpack_public_path__ + "img/process-1.8a6ce3dc.png";